export const i18n = {
  validation: {
    missing: 'Hier fehlt noch eine Angabe.',
    invalid: 'Hier stimmt was nicht.',
    coupon:
      'Das ist leider kein gültiger Gutschein-Code. Bitte prüfe deine Eingabe nochmal. Vielleicht ist der Gutschein auch abgelaufen oder nur für andere Produkte gültig.',
    street: 'Bitte gib einen gültigen Straßennamen ein.',
    zip: 'Bitte gib eine Postleitzahl mit 5 Ziffern ein.',
    phone:
      'Bitte achte darauf, dass die Telefonnummer mit einem + oder einer 0 startet, mindestens 6 Ziffern hat und mit einer Ziffer endet.',
    email: 'Bitte gib eine gültige E-Mail-Adresse ein.',
  },
  form: {
    submit: 'Weiter',
    register: 'Jetzt anmelden',
    toHome: 'Zurück zur Homepage',
  },
  modal: {
    confirm: 'Okay, verstanden',
    close: 'Schließen',
  },
  overview: {
    documents: 'Wichtige Dokumente',
    revocation: 'Widerrufsformular',
    submit: 'Vertrag abschließen',
    submitError: 'Beim Senden der Bestellung ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.',
  },
  footnotes: {
    electricityPriceGuarantee:
      'Die Energiepreisgarantie sichert feste Preise für Beschaffungs- und Vertriebskosten während der gesamten Erstvertragslaufzeit. Ausgenommen von der Preisgarantie sind nicht beeinflussbare Kostenbestandteile, wie Umlagen, Abgaben, Netzentgelte, Entgelte für den Messstellenbetrieb und Steuern (gem. Ziffer 5 der AGB) sowie neue staatlich veranlasste Steuern, Abgaben und Umlagen oder sonstige neue staatlich veranlasste Mehr- oder Minderbelastungen, die die Beschaffung, Gewinnung, Erzeugung, Speicherung und den Verbrauch von elektrischer Energie, die Netznutzung oder den Messstellenbetrieb betreffen.',
    gasPriceGuarantee:
      'Die Energiepreisgarantie sichert feste Preise für Beschaffungs- und Vertriebskosten während der gesamten Erstvertragslaufzeit. Ausgenommen sind Abgaben, Umlagen, Steuern, Netznutzungs- und Messstellenbetriebskosten, Konzessionsabgabe, Kosten für Emissionszertifikate sowie neue staatlich veranlasste Steuern, Abgaben, Umlagen oder sonstige Mehr- oder Minderbelastungen, die die Beschaffung, Gewinnung, Erzeugung, Speicherung und den Verbrauch von Gas, die Netznutzung oder den Messstellenbetrieb betreffen.',
  },
} as const;
